import { OfflineData } from '@tencent/docs_offline';
import {
    DOCUMENT_DATA_TYPE,
    DOCUMENT_TYPE,
    DOCUMENT_STATUS,
} from '@tencent/ark-model';
import { IMutationsPackExtended } from '@tencent/slide-sdk-persistent';
import { IOfflineEditContext } from '../core/interfaces/offline-edit-context.interace';
import { DVER, SUB_ID } from '../constants';

/**
 * clientVars 转换为可存储到本地数据库的 OfflineData
 * @param context
 * @param clientVars
 * @param isNewCreate
 * @returns
 */
export function clientVars2OfflineData(
    context: IOfflineEditContext,
    clientVars: ClientVars,
    isNewCreate?: boolean,
): OfflineData {
    const { uid, secretId, globalPadId, createMessageSeq } = context;
    return new OfflineData({
        key: `${globalPadId}_${SUB_ID}_${uid}`,
        uid,
        secretId,
        globalPadId,
        type: DOCUMENT_DATA_TYPE.init as any,
        docType: DOCUMENT_TYPE.slide as any,
        padStatus: clientVars.status || isNewCreate ? DOCUMENT_STATUS.new as any : undefined,
        subSheetId: SUB_ID,
        taskId: createMessageSeq(),
        version: clientVars.collab_client_vars?.rev,
        dver: clientVars?.collab_client_vars?.dver || DVER,
        data: clientVars,
        createTime: Date.now(),
    });
}

/**
 * 当前变更 mutationsPackCaches 转换为可存储到本地数据库的 OfflineData
 * @param context
 * @param mutationsPackCaches
 * @returns
 */
export function mutationsPack2OfflineData(
    context: IOfflineEditContext,
    mutaionsPackCaches: IMutationsPackExtended[],
): OfflineData {
    const { uid, secretId, globalPadId, createMessageSeq } = context;
    const [mutaionsPack] = mutaionsPackCaches;
    return new OfflineData({
        key: `${globalPadId}_${SUB_ID}_${uid}`,
        uid,
        secretId,
        globalPadId,
        type: DOCUMENT_DATA_TYPE.committing as any,
        docType: DOCUMENT_TYPE.slide as any,
        subSheetId: SUB_ID,
        taskId: mutaionsPack.taskId || createMessageSeq(),
        version: mutaionsPack?.revision,
        dver: DVER,
        data: mutaionsPackCaches,
        createTime: Date.now(),
    });
}
